import React, { useState } from "react";
import styles from "./styles.css";
import WarrantyCover from "../images/warranty-cover.svg";
import ManufacturerLevelCoverage from "../../../shared/cars24-cover-pitching/manufacturer-level-coverage/component";
import ChooseYourPlanGraph from "../../../shared/cars24-cover-pitching/choose-your-plan-graph/component";
import PropTypes from "prop-types";
import WarrantyModal from "../../post-payment-journey/add-ons-plans/warranty-modal/component";
import CarServicingDidYouKnowCard from "../../../shared/cars24-cover-pitching/car-servicing-did-you-know-card";
import CarServicingHappyCustomerCard from "../../../shared/cars24-cover-pitching/car-servicing-happy-customer-card";
import MechanicCard from "../../../shared/cars24-cover-pitching/mechanic-card/component";
import { VAS_CATEGORY_KEYS } from "../../../../constants/checkout-constants";
import TrackImpression from "../../../shared/track-impression";
import { PLATINUM_COVER_GA_EVENTS } from "../tracking";

export const TopWarrantyPitch = ({ carCoverMetadata }) => {
    const [isModalOpen, setIsModalOpen] = useState(null);
    const { bannerData, graphData, infoCard } = carCoverMetadata || {};

    const handleWhyUsModal = (tab) => {
        setIsModalOpen(tab);
    };

    return (
        <div styleName={"styles.wrapper"}>
            {/* Top Section */}
            <div styleName={"styles.outer"}>
                <div styleName={"styles.innerWrapper"}>
                    <div className="media" styleName={"styles.mediaContainer"}>
                        <div className="media-body">
                            <div styleName={"styles.contentWrapper"}>
                                <div>
                                    <p styleName={"styles.subheading"}>Extend your warranty</p>
                                    <p styleName={"styles.heading"}>CARS24 Platinum cover</p>
                                    <p styleName={"styles.subheading"}>
                                        Save big on unexpected repair costs with ultimate protection.
                                    </p>
                                </div>
                                <img src={WarrantyCover} alt="CARS24 Warranty cover" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Car illustration section */}
            {bannerData && <div styleName="styles.carWrapper">
                <ManufacturerLevelCoverage bannerData={bannerData} onModalOpen={() => handleWhyUsModal("WHATS_COVERED")} />
            </div>}

            {infoCard && <div styleName={"styles.didYouKnow"}>
                <CarServicingDidYouKnowCard {...infoCard} />
            </div>}

            {/* Choose your plan graph */}
            {graphData && <div styleName="styles.graphWrapper">
                <TrackImpression event={{
                    data: {
                        ...PLATINUM_COVER_GA_EVENTS.CHOOSE_YOUR_PLAN_GRAPH,
                        eventLabel: "Graph"
                    }
                }}>
                    <ChooseYourPlanGraph graphData={graphData} />
                </TrackImpression>
            </div>}

            <WarrantyModal
                isOpen={isModalOpen}
                planKey={VAS_CATEGORY_KEYS.WARRANTY}
                onClose={() => setIsModalOpen(false)}
                isWhatsCovered={isModalOpen === "WHATS_COVERED"}
                isPitching={true}
            />
        </div>
    );
};

TopWarrantyPitch.propTypes = {
    carCoverMetadata: PropTypes.object
};

export const BottomWarrantyPitch = ({ carCoverMetadata }) => {
    const { technicianDetails, promotionData } = carCoverMetadata || {};

    return (
        <div>
            {promotionData && <div styleName={"styles.happyCustomerCardWrapper"}>
                <CarServicingHappyCustomerCard promotionData={promotionData} />
            </div>}
            {technicianDetails?.length > 0 &&
                <div styleName={"styles.mechanicCardWrapper"}>
                    <MechanicCard technicianDetails={technicianDetails[0]} />
                </div>}
        </div>
    );
};

BottomWarrantyPitch.propTypes = {
    carCoverMetadata: PropTypes.object
};
